import { render } from "./StorePolicyEditor.vue?vue&type=template&id=3ec4168d&scoped=true"
import script from "./StorePolicyEditor.vue?vue&type=script&lang=js"
export * from "./StorePolicyEditor.vue?vue&type=script&lang=js"

import "./StorePolicyEditor.vue?vue&type=style&index=0&id=3ec4168d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec4168d"]])

export default __exports__